/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import { View, TouchableOpacity, Dimensions } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '@global/colors';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import { showPopup } from '@/store/modal';
import { isNative } from '@global/screens';

const FilterButton = (props) => {
  const dispatch = useDispatch();
  const isShowFilter = useSelector((state) => state.modal.showFilter);
  const filter = useSelector((state) => state.params.filter);
  const searchKey = props.searchKey ? props.searchKey : null;
  const hasFilter =
    filter &&
    Object.keys(filter).filter((a) => (searchKey ? a != searchKey : true))
      .length > 0;
  const name = props.name ? props.name : true;

  const openFilter = () => {
    if (props.onPress) {
      props.onPress();
    } else {
      dispatch(
        showPopup({ name: 'showFilter', value: isShowFilter ? false : name }),
      );
    }
  };

  const FilterIcon = React.useMemo(() => {
    return hasFilter ? (
      <Image
        width={17}
        height={17}
        style={{ width: 17, height: 17 }}
        svg={true}
        source={require('@assets/img/icons/check-circle-white.svg')}
      />
    ) : (
      <Image
        width={17}
        height={17}
        style={{ width: 17, height: 17 }}
        svg={true}
        source={require('@assets/img/icons/filter-white.svg')}
      />
    );
  }, [hasFilter]);

  return isNative || Dimensions.get('window').width < 991 ? (
    <View style={{ flexDirection: 'row', marginRight: 12 }}>
      <TouchableOpacity
        style={{
          flexDirection: 'row',
          alignItems: 'center',
        }}
        onPress={() => openFilter()}>
        <SociollaText
          type="medium"
          style={{
            fontSize: 16,
            color: Colors.white,
            letterSpacing: 0.5,
            marginRight: 6,
          }}>
          Filter
        </SociollaText>
        {FilterIcon}
      </TouchableOpacity>
    </View>
  ) : (
    false
  );
};

export default React.memo(FilterButton, (prev, next) => prev == next);
